import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {Veranstaltungen2Page} from './veranstaltungen.page';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {reducers} from './veranstaltungen.reducer';
import {VeranstaltungenPageUiEffects} from './veranstaltungen.effects.ui';
import {
    VeranstaltungenAufgabeAktivierenEffects,
    VeranstaltungenAufgabeAktualisierenEffects,
    VeranstaltungenAufgabeDeaktivierenEffects, VeranstaltungenAufgabenBenutzerBerechtigungenEntfernenEffects, VeranstaltungenAufgabenBenutzerBerechtigungenHinzufuegenEffects,
    VeranstaltungenBenutzerVomDienstBefreienEffects,
    VeranstaltungenBenutzerZumDienstEinteilenMultiEffects,
    VeranstaltungenChecklisteAbarbeiterRollenAdminEffects,
    VeranstaltungenChecklisteAufgabenAdminEffects,
    VeranstaltungenChecklisteEntfernenEffects,
    VeranstaltungenChecklisteFreigabeRollenAdminEffects,
    VeranstaltungenChecklisteHinzufuegenMultiEffects,
    VeranstaltungenChecklisteLeseRollenAdminEffects,
    VeranstaltungenDokumentAktualisierenEffects, VeranstaltungenDokumentBearbeitenBerechtigungEntfernenEffects, VeranstaltungenDokumentBearbeitenBerechtigungEntfernenMultiEffects, VeranstaltungenDokumentBearbeitenBerechtigungHinzufuegenMultiEffects,
    VeranstaltungenDokumentBerechtigungEntfernenEffects,
    VeranstaltungenDokumentBerechtigungEntfernenMultiEffects,
    VeranstaltungenDokumentBerechtigungHinzufuegenMultiEffects,
    VeranstaltungenDokumentEntfernenEffects,
    VeranstaltungenDokumentHinzufuegenEffects,
    VeranstaltungenDokumentUploadAktualisierenEffects,
    VeranstaltungenFunktionsbereichChecklistenAdminEffects,
    VeranstaltungenFunktionsbereichEntfernenEffects,
    VeranstaltungenFunktionsbereichHinzufuegenMultiEffects,
    VeranstaltungenRolleBenutzerAdminEffects,
    VeranstaltungenVeranstaltungAktionEntfernenEffects,
    VeranstaltungenVeranstaltungAktionErfassenEffects,
    VeranstaltungenVeranstaltungAktionReihenfolgeSetzenEffects,
    VeranstaltungenVeranstaltungAnlegenEffects,
    VeranstaltungenVeranstaltungBeendenEffects, VeranstaltungenVeranstaltungBerechtigungenAdminEffects,
    VeranstaltungenVeranstaltungDetailAdminEffects, VeranstaltungenVeranstaltungDokumentBerechtigungEffects,
    VeranstaltungenVeranstaltungDokumenteAdminEffects,
    VeranstaltungenVeranstaltungenAngelegteAdminEffects,
    VeranstaltungenVeranstaltungenBeendeteAdminEffects,
    VeranstaltungenVeranstaltungenVeroeffentlichteAdminEffects,
    VeranstaltungenVeranstaltungFreigebenEffects, VeranstaltungenVeranstaltungFunktionsbereichAufgabenBenutzerBerechtigungenAdminEffects,
    VeranstaltungenVeranstaltungFunktionsbereicheAdminEffects,
    VeranstaltungenVeranstaltungFunktionsbereicheChecklistenAdminEffects,
    VeranstaltungenVeranstaltungFunktionsbereicheRollenAdminAlleEffects,
    VeranstaltungenVeranstaltungFunktionsbereicheRollenAdminEffects,
    VeranstaltungenVeranstaltungInfoKategorieEntfernenEffects,
    VeranstaltungenVeranstaltungInfoKategorieErfassenEffects,
    VeranstaltungenVeranstaltungInfoKategorieReihenfolgeSetzenEffects,
    VeranstaltungenVeranstaltungKopfdatenAktualisierenEffects,
    VeranstaltungenVeranstaltungKopierenEffects,
    VeranstaltungenVeranstaltungLoeschenEffects,
    VeranstaltungenVeranstaltungLogoAktualisierenEffects,
    VeranstaltungenVeranstaltungNichtVeroeffentlichenEffects, VeranstaltungenVeranstaltungPhaseBeendenEffects,
    VeranstaltungenVeranstaltungReaktivierenEffects,
    VeranstaltungenVeranstaltungStatusEffects,
    VeranstaltungenVeranstaltungVeroeffentlichenEffects
} from '../../../client-ngrx/veranstaltungen';
import {SopiScrollModule} from '../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {SopiComponentsModule} from '../../shared/sopi-components/sopi-components.module';
import { EffectsWs } from './veranstaltungen.effects.ws';
import {MarkdownModule} from 'ngx-markdown';
import {SopiDirectivesModule} from '../../../sopi/directives/sopi-directives.module';
import {ComponentsModule} from '../../../sopi/components/components.module';
import {PandemieVeranstaltungPandemieCheckEffects, PandemieVeranstaltungPandemieInfoEffects, PandemieVeranstaltungPandemieLevelSetzenEffects} from '../../../client-ngrx/pandemie';
import {PipesModule} from '../../../sopi/pipes/pipes.module';
import {VeranstaltungstypenVeranstaltungsTypRolleBenutzerEffects} from '../../../client-ngrx/veranstaltungstypen';
import {PopoverComponentModule} from '../aufgaben-berechtigungen/popover-component/popover-component.module';
import {VeranstaltungenInfoKategorienPage} from './veranstaltungen-info-kategorien/veranstaltungen-info-kategorien.page';
import {VeranstaltungenInfoKategorienPageModule} from './veranstaltungen-info-kategorien/veranstaltungen-info-kategorien.module';
import {VeranstaltungenAktionenPage} from './veranstaltungen-aktionen/veranstaltungen-aktionen.page';
import {VeranstaltungenAktionenPageModule} from './veranstaltungen-aktionen/veranstaltungen-aktionen.module';

const routes: Routes = [
    {
        path: '',
        component: Veranstaltungen2Page
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),

        MarkdownModule.forChild(),

        StoreModule.forFeature('VeranstaltungenPage', reducers),
        EffectsModule.forFeature([
            VeranstaltungenPageUiEffects,
            EffectsWs,
            /* VERANSTALTUNGEN */
            // GET
            VeranstaltungenChecklisteAbarbeiterRollenAdminEffects,
            VeranstaltungenChecklisteAufgabenAdminEffects,
            VeranstaltungenChecklisteFreigabeRollenAdminEffects,
            VeranstaltungenChecklisteLeseRollenAdminEffects,
            VeranstaltungenFunktionsbereichChecklistenAdminEffects,
            VeranstaltungenRolleBenutzerAdminEffects,
            VeranstaltungenVeranstaltungDetailAdminEffects,
            VeranstaltungenVeranstaltungDokumenteAdminEffects,
            VeranstaltungenVeranstaltungenAngelegteAdminEffects,
            VeranstaltungenVeranstaltungenBeendeteAdminEffects,
            VeranstaltungenVeranstaltungenVeroeffentlichteAdminEffects,
            VeranstaltungenVeranstaltungFunktionsbereicheAdminEffects,
            VeranstaltungenVeranstaltungFunktionsbereicheChecklistenAdminEffects,
            VeranstaltungenVeranstaltungFunktionsbereicheRollenAdminEffects,
            VeranstaltungenVeranstaltungFunktionsbereicheRollenAdminAlleEffects,
            VeranstaltungenVeranstaltungStatusEffects,
            VeranstaltungenVeranstaltungDokumentBerechtigungEffects,
            VeranstaltungenVeranstaltungBerechtigungenAdminEffects,

            // POST
            VeranstaltungenAufgabeAktivierenEffects,
            VeranstaltungenAufgabeDeaktivierenEffects,
            VeranstaltungenBenutzerVomDienstBefreienEffects,
            VeranstaltungenBenutzerZumDienstEinteilenMultiEffects,
            VeranstaltungenChecklisteHinzufuegenMultiEffects,
            VeranstaltungenDokumentAktualisierenEffects,
            VeranstaltungenDokumentBerechtigungEntfernenEffects,
            VeranstaltungenDokumentBearbeitenBerechtigungEntfernenEffects,
            VeranstaltungenDokumentBerechtigungEntfernenMultiEffects,
            VeranstaltungenDokumentBearbeitenBerechtigungEntfernenMultiEffects,
            VeranstaltungenDokumentEntfernenEffects,
            VeranstaltungenDokumentHinzufuegenEffects,
            VeranstaltungenDokumentUploadAktualisierenEffects,
            VeranstaltungenVeranstaltungAktionEntfernenEffects,
            VeranstaltungenVeranstaltungAktionErfassenEffects,
            VeranstaltungenVeranstaltungAktionReihenfolgeSetzenEffects,
            VeranstaltungenVeranstaltungAnlegenEffects,
            VeranstaltungenVeranstaltungBeendenEffects,
            VeranstaltungenVeranstaltungLoeschenEffects,
            VeranstaltungenVeranstaltungFreigebenEffects,
            VeranstaltungenVeranstaltungInfoKategorieEntfernenEffects,
            VeranstaltungenVeranstaltungInfoKategorieErfassenEffects,
            VeranstaltungenVeranstaltungInfoKategorieReihenfolgeSetzenEffects,
            VeranstaltungenVeranstaltungKopfdatenAktualisierenEffects,
            VeranstaltungenVeranstaltungLogoAktualisierenEffects,
            VeranstaltungenVeranstaltungReaktivierenEffects,
            VeranstaltungenVeranstaltungVeroeffentlichenEffects,
            VeranstaltungenFunktionsbereichHinzufuegenMultiEffects,
            VeranstaltungenFunktionsbereichEntfernenEffects,
            VeranstaltungenDokumentBerechtigungHinzufuegenMultiEffects,
            VeranstaltungenDokumentBearbeitenBerechtigungHinzufuegenMultiEffects,
            VeranstaltungenChecklisteEntfernenEffects,
            VeranstaltungenChecklisteHinzufuegenMultiEffects,
            VeranstaltungenVeranstaltungKopierenEffects,
            VeranstaltungenAufgabeAktualisierenEffects,
            VeranstaltungenVeranstaltungNichtVeroeffentlichenEffects,
            VeranstaltungenVeranstaltungPhaseBeendenEffects,


            /* VERANSTALTUNGSTYP */
            VeranstaltungstypenVeranstaltungsTypRolleBenutzerEffects,

            /* PANDEMIE */
            PandemieVeranstaltungPandemieCheckEffects,
            PandemieVeranstaltungPandemieLevelSetzenEffects,
            PandemieVeranstaltungPandemieInfoEffects,

            /* AUFGABEN BERECHTIGUNGEN */
            VeranstaltungenVeranstaltungFunktionsbereichAufgabenBenutzerBerechtigungenAdminEffects,
            VeranstaltungenAufgabenBenutzerBerechtigungenEntfernenEffects,
            VeranstaltungenAufgabenBenutzerBerechtigungenHinzufuegenEffects
        ]),
        SopiComponentsModule.forRoot(),
        SopiDirectivesModule.forRoot(),
        ReactiveFormsModule,
        SopiScrollModule,
        ComponentsModule,
        PipesModule,
        PopoverComponentModule,
        VeranstaltungenInfoKategorienPageModule,
        VeranstaltungenAktionenPageModule
    ],
    declarations: [Veranstaltungen2Page, VeranstaltungenInfoKategorienPage, VeranstaltungenAktionenPage],
    providers: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    entryComponents: [VeranstaltungenInfoKategorienPage, VeranstaltungenAktionenPage]
})
export class Veranstaltungen2PageModule {
}
